import { BrandMark } from "../brand/BrandMark";

/**
 * The app's one loading splash (issue #1079, D118). `AppStates.dc.html`
 * draws it three times with three ids: `auth-loading` (the session is not
 * known yet), `onboarding-loading` and `coach-setup-loading` (the status
 * fetch of the two set-up gates). One picture, so one component; the id is
 * the caller's `testId`, the sentence is unchanged, journeys and the
 * responsive harness name both.
 *
 * Drawn values, read off the artboard's `auth-loading` block: the drawn
 * mark (the traced logo, the same `BrandMark` the kit TopBar draws,
 * not `CompassLogo`'s lockup) at 64px, 16px gap, the line at 14px in the muted ink, centred on the white
 * surface. #1153 (D307): the splash renders in both looks, so its artwork
 * changes with the rest of the logo. No top bar: nothing is known yet to put in it.
 *
 * NOT BUILT, on purpose: the artboard's `demo-banner` and `demo-switching`
 * states. D205 (#1023) removed the public demo, so there is nothing to draw
 * them for.
 */
export function LoadingSplash({ testId, line = "Getting your bearings…" }) {
  return (
    <div
      data-testid={testId}
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        backgroundColor: "var(--nw-surface)",
      }}
    >
      {/* D322 (#1153): the logo stays upright. No rotation, no replacement animation. */}
      <div className="inline-block">
        <BrandMark size={64} variant="light" testId="topbar-mark" />
      </div>
      <p style={{ margin: 0, fontSize: 14, color: "var(--nw-ink-muted)" }}>{line}</p>
    </div>
  );
}
